<template>
  <div class="d-inline">
    <button
      v-for="item in items"
      :id="`switchButton${item.value}`"
      :key="item.value"
      :class="['btn', {'active': item.value == value}]"
      @click="() => onClick(item.value)"
    >
      <font-awesome-icon :icon="item.icon" />
    </button>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    buttons: Array,
    onClick: Function
  },
  data () {
    return {
      items: this.buttons
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .btn {
    width: 30px;
    height: 30px;
    border-color: #927FDA;
    border-radius: 2px;
    &.active{
      background-color: $royalpurple-dark;
      svg{
        color: white;
      }
    }
    &+.btn{
      margin-left: 0;
      border-left: 0;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    &:first-child, &:not(:first-child):not(:last-child){
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
</style>
